(function () {
  // Solo su pagine prodotto
  if (!document.body.className.includes('template-product')) return;

  var bar = document.getElementById('BeellyStickyATC');
  if (!bar) return;

  var titleEl = document.getElementById('BeellyStickyATCTitle');
  var priceEl = document.getElementById('BeellyStickyATCPrice');
  var btn = document.getElementById('BeellyStickyATCBtn');

  // Bottone originale del tema
  var mainBtn = document.getElementById('AddToCart');

  // Alcuni temi hanno prezzo in #ProductPrice
  function getPriceText() {
    var el =
      document.getElementById('ProductPrice') ||
      document.querySelector('.product_price') ||
      document.querySelector('[data-product-price]');

    if (!el) return '—';
    var t = (el.textContent || '').trim();
    return t || '—';
  }

  function getTitleText() {
    var el =
      document.querySelector('.product_single_detail_section h1') ||
      document.querySelector('.product-single__title') ||
      document.querySelector('h1');

    if (!el) return '—';
    var t = (el.textContent || '').trim();
    return t || '—';
  }

  function syncState() {
    // Se il bottone principale non c’è, non possiamo fare sticky ATC
    if (!mainBtn) {
      bar.classList.remove('is-visible');
      bar.setAttribute('aria-hidden', 'true');
      return;
    }

    // Titolo + prezzo
    titleEl.textContent = getTitleText();
    priceEl.textContent = getPriceText();

    // Copia testo dal bottone principale (AddToCartText) se presente
    var mainText = document.getElementById('AddToCartText');
    if (mainText && mainText.textContent.trim()) {
      btn.textContent = mainText.textContent.trim();
    }

    // Stato disabled
    btn.disabled = !!mainBtn.disabled;
  }

  function show() {
    bar.classList.add('is-visible');
    bar.setAttribute('aria-hidden', 'false');
  }

  function hide() {
    bar.classList.remove('is-visible');
    bar.setAttribute('aria-hidden', 'true');
  }

  // Mostra barra solo quando il bottone principale NON è visibile
  function initVisibilityObserver() {
    if (!mainBtn || !('IntersectionObserver' in window)) {
      // Fallback semplice
      window.addEventListener('scroll', function () {
        if (!mainBtn) return;
        var r = mainBtn.getBoundingClientRect();
        var visible = r.top >= 0 && r.bottom <= (window.innerHeight || document.documentElement.clientHeight);
        if (visible) hide(); else if (window.innerWidth < 769) show();
      }, { passive: true });
      return;
    }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        // Se il bottone originale è visibile -> nascondi sticky
        if (entry.isIntersecting) hide();
        else {
          // Mostra solo mobile
          if (window.innerWidth < 769) show();
        }
      });
    }, { threshold: 0.15 });

    io.observe(mainBtn);
  }

  // Click sulla sticky → inoltra al flusso originale (form submit)
  btn.addEventListener('click', function () {
    if (!mainBtn || mainBtn.disabled) return;

    // Preferibile: submit del form originale
    var form = mainBtn.closest('form');
    if (form && form.requestSubmit) {
      form.requestSubmit(mainBtn);
      return;
    }
    // fallback
    mainBtn.click();
  });

  // Aggiorna quando cambia variante / qty / ecc.
  document.addEventListener('change', function (e) {
    // variazioni tipiche in Shopify
    if (e.target && (e.target.name === 'id' || e.target.closest('[name="id"]'))) {
      setTimeout(syncState, 50);
    }
  });

  // Aggiorna anche quando il tema aggiorna prezzi via JS
  var priceTimer = setInterval(function () {
    // evita loop infinito su pagine strane
    if (!document.body.className.includes('template-product')) {
      clearInterval(priceTimer);
      return;
    }
    syncState();
  }, 1200);

  // Init
  syncState();
  initVisibilityObserver();
})();
